export default __webpack_public_path__ + "static/media/donuts.4d15c8da.jpg";